module.exports = __webpack_public_path__ + "e4.no2.e4f2e2b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/e4.no2.jpg
// module id = qYmH
// module chunks = 0